<template>
  <footer class="footer tw-bg-[var(--c-primary)] tw-py-10 tw-pt-20 tw-text-white">
    <div class="container tw-mx-auto tw-px-4">
      <div class="tw-mb-12 tw-grid tw-grid-cols-1 tw-gap-8 lg:tw-grid-cols-12">
        <!-- LOGO ve İletişim Bloğu -->
        <div class="tw-order-1 tw-flex tw-flex-col tw-items-start lg:tw-order-2 lg:tw-col-span-8 lg:tw-items-center">
          <!-- Logo -->
          <NuxtImg :src="logo" alt="Roderick Thomas Estate Agents" class="tw-mb-8 tw-w-64 lg:tw-w-80" />
          <!-- Telefon -->

          <div class="tw-mb-8 tw-flex tw-gap-3">
            <nuxt-link
              v-if="vars.facebookUrl"
              :to="vars.facebookUrl"
              :external="true"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px]"
            >
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.4245" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
                <path
                  d="M17.6218 17.0921H19.121L19.7208 14.6932H17.6218V13.4938C17.6218 12.8761 17.6218 12.2944 18.8212 12.2944H19.7208V10.2794C19.5252 10.2536 18.787 10.1954 18.0074 10.1954C16.3792 10.1954 15.2229 11.1891 15.2229 13.0141V14.6932H13.4238V17.0921H15.2229V22.1896H17.6218V17.0921Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>

            <nuxt-link
              v-if="vars.instagramUrl"
              :to="vars.instagramUrl"
              target="_blank"
              :external="true"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.8093" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
                <path
                  d="M14.2888 10.1952H19.3264C21.2455 10.1952 22.8047 11.7544 22.8047 13.6735V18.711C22.8047 19.6335 22.4382 20.5183 21.7859 21.1706C21.1336 21.8229 20.2489 22.1893 19.3264 22.1893H14.2888C12.3698 22.1893 10.8105 20.6301 10.8105 18.711V13.6735C10.8105 12.751 11.177 11.8663 11.8293 11.214C12.4816 10.5617 13.3663 10.1952 14.2888 10.1952ZM14.1689 11.3946C13.5963 11.3946 13.0472 11.6221 12.6423 12.0269C12.2374 12.4318 12.01 12.981 12.01 13.5536V18.831C12.01 20.0244 12.9755 20.9899 14.1689 20.9899H19.4463C20.0189 20.9899 20.5681 20.7625 20.9729 20.3576C21.3778 19.9527 21.6053 19.4036 21.6053 18.831V13.5536C21.6053 12.3601 20.6397 11.3946 19.4463 11.3946H14.1689ZM19.9561 12.2942C20.1549 12.2942 20.3456 12.3731 20.4862 12.5137C20.6267 12.6543 20.7057 12.845 20.7057 13.0438C20.7057 13.2426 20.6267 13.4333 20.4862 13.5739C20.3456 13.7145 20.1549 13.7934 19.9561 13.7934C19.7573 13.7934 19.5666 13.7145 19.426 13.5739C19.2854 13.4333 19.2064 13.2426 19.2064 13.0438C19.2064 12.845 19.2854 12.6543 19.426 12.5137C19.5666 12.3731 19.7573 12.2942 19.9561 12.2942ZM16.8076 13.1937C17.6029 13.1937 18.3656 13.5096 18.9279 14.072C19.4902 14.6343 19.8062 15.397 19.8062 16.1923C19.8062 16.9875 19.4902 17.7502 18.9279 18.3125C18.3656 18.8749 17.6029 19.1908 16.8076 19.1908C16.0124 19.1908 15.2497 18.8749 14.6873 18.3125C14.125 17.7502 13.8091 16.9875 13.8091 16.1923C13.8091 15.397 14.125 14.6343 14.6873 14.072C15.2497 13.5096 16.0124 13.1937 16.8076 13.1937ZM16.8076 14.3931C16.3305 14.3931 15.8728 14.5827 15.5354 14.9201C15.198 15.2575 15.0085 15.7151 15.0085 16.1923C15.0085 16.6694 15.198 17.127 15.5354 17.4644C15.8728 17.8018 16.3305 17.9914 16.8076 17.9914C17.2848 17.9914 17.7424 17.8018 18.0798 17.4644C18.4172 17.127 18.6067 16.6694 18.6067 16.1923C18.6067 15.7151 18.4172 15.2575 18.0798 14.9201C17.7424 14.5827 17.2848 14.3931 16.8076 14.3931Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.youtubeUrl"
              :to="vars.youtubeUrl"
              :external="true"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.5769" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
                <path
                  d="M16.5752 11.3946C17.0879 11.3946 17.6139 11.4078 18.1236 11.4294L18.7257 11.4582L19.3021 11.4923L19.8418 11.5289L20.3348 11.5673C20.8697 11.6083 21.3731 11.8365 21.7564 12.212C22.1396 12.5875 22.3782 13.0861 22.4301 13.6201L22.4541 13.875L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7818 22.5411 17.3983 22.4991 17.9638L22.4541 18.5095C22.4463 18.5971 22.4385 18.6816 22.4301 18.7644C22.3782 19.2985 22.1395 19.7972 21.7562 20.1727C21.3728 20.5482 20.8692 20.7764 20.3342 20.8172L19.8424 20.855L19.3027 20.8922L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9899C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8922L13.3086 20.855L12.8156 20.8172C12.2807 20.7762 11.7773 20.548 11.394 20.1725C11.0107 19.797 10.7722 19.2984 10.7203 18.7644L10.6963 18.5095L10.6513 17.9638C10.6054 17.3744 10.581 16.7835 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.875C10.7041 13.7874 10.7119 13.7029 10.7203 13.6201C10.7722 13.0862 11.0106 12.5877 11.3938 12.2122C11.7769 11.8367 12.2802 11.6084 12.815 11.5673L13.3074 11.5289L13.8471 11.4923L14.424 11.4582L15.0262 11.4294C15.5422 11.407 16.0587 11.3954 16.5752 11.3946ZM16.5752 12.594C16.0804 12.594 15.5713 12.6072 15.0759 12.6276L14.4894 12.6558L13.9263 12.6888L13.3973 12.7247L12.9128 12.7625C12.6581 12.7806 12.4181 12.8883 12.2352 13.0664C12.0523 13.2446 11.9384 13.4817 11.9137 13.7358C11.8435 14.4609 11.7775 15.3635 11.7775 16.1922C11.7775 17.021 11.8435 17.9236 11.9137 18.6487C11.9646 19.1716 12.3796 19.5782 12.9128 19.622L13.3973 19.6592L13.9263 19.6951L14.4894 19.7287L15.0759 19.7569C15.5713 19.7773 16.0804 19.7905 16.5752 19.7905C17.07 19.7905 17.5791 19.7773 18.0745 19.7569L18.661 19.7287L19.2241 19.6957L19.753 19.6598L20.2376 19.622C20.4923 19.6039 20.7323 19.4962 20.9152 19.3181C21.0981 19.1399 21.212 18.9028 21.2367 18.6487C21.3069 17.9236 21.3729 17.021 21.3729 16.1922C21.3729 15.3635 21.3069 14.4609 21.2367 13.7358C21.212 13.4817 21.0981 13.2446 20.9152 13.0664C20.7323 12.8883 20.4923 12.7806 20.2376 12.7625L19.753 12.7253L19.2241 12.6894L18.661 12.6558L18.0745 12.6276C17.575 12.6061 17.0751 12.5949 16.5752 12.594ZM15.3758 14.738C15.3757 14.6793 15.39 14.6216 15.4174 14.5698C15.4447 14.5179 15.4843 14.4736 15.5328 14.4405C15.5812 14.4075 15.6369 14.3868 15.6952 14.3802C15.7534 14.3736 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8804C18.4844 15.9093 18.5269 15.95 18.558 15.9988C18.5891 16.0477 18.6079 16.1033 18.6129 16.161C18.6179 16.2187 18.6089 16.2767 18.5867 16.3302C18.5645 16.3837 18.5297 16.431 18.4853 16.4681L18.4343 16.5041L15.9155 17.9584C15.8648 17.9878 15.8076 18.0043 15.749 18.0066C15.6904 18.0088 15.6321 17.9967 15.5792 17.9713C15.5264 17.9458 15.4805 17.9079 15.4457 17.8607C15.4109 17.8135 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.738Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.tiktokUrl"
              :to="vars.tiktokUrl"
              :external="true"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.1921" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
                <path
                  d="M18.9506 12.4802C18.5406 12.0122 18.3147 11.4112 18.3149 10.7891H16.4618V18.2254C16.4475 18.6279 16.2776 19.009 15.9879 19.2887C15.6982 19.5683 15.3112 19.7246 14.9086 19.7247C14.057 19.7247 13.3493 19.029 13.3493 18.1655C13.3493 17.134 14.3448 16.3603 15.3703 16.6782V14.7831C13.3014 14.5072 11.4902 16.1145 11.4902 18.1655C11.4902 20.1625 13.1454 21.5838 14.9026 21.5838C16.7856 21.5838 18.3149 20.0545 18.3149 18.1655V14.3933C19.0663 14.9329 19.9685 15.2225 20.8936 15.2209V13.3678C20.8936 13.3678 19.7662 13.4218 18.9506 12.4802Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
          </div>

          <!-- Mail -->

          <!-- Contact Us -->
          <div class="tw-mb-8 tw-flex tw-flex-wrap tw-justify-start tw-gap-x-6">
            <div
              v-for="(card, index) in cards"
              :key="index"
              class="mt-2 tw-flex tw-w-full tw-flex-row tw-items-center tw-gap-x-1 sm:tw-w-auto"
            >
              <p class="tw-m-0 !tw-text-white">
                {{ card.title }}
              </p>
              <p class="tw-m-0 !tw-text-white">
                {{ card.number }}
              </p>
            </div>
          </div>

          <!-- Register to Property Alerts -->

          <!-- Örnek bloklar -->
        </div>

        <!-- Menü Bloğu -->
        <div v-if="columns1" class="tw-order-2 lg:tw-order-1 lg:tw-col-span-2">
          <h6 class="tw-mb-8">{{ vars.columnTitle1Text }}</h6>
          <div class="footer__list tw-flex tw-flex-col tw-space-y-3">
            <nuxt-link
              v-for="(item, index) in columns1"
              :to="item.link"
              :external="true"
              :key="index"
              class="n-link tw-block hover:tw-text-[var(--c-secondary)]"
            >
              <p>{{ item.item }}</p>
            </nuxt-link>
          </div>
        </div>

        <!-- Bilgilendirme/Künye Bloğu -->
        <div class="info tw-order-3 tw-space-y-2 lg:tw-order-3 lg:tw-col-span-2">
          <p>{{ vars.companyTradingAsText }}, Trading As:</p>
          <p>{{ company.name }}</p>
          <p>Company Number: {{ vars.companyNumberText }}</p>
          <p>Registered Address: {{ vars.companyAddressText }}</p>
          <p>
            Redress Scheme:
            {{ vars.companyRedressSchemeText }}
          </p>
          <p>
            <a
              :href="vars.companyRedressSchemeLinkUrl"
              class="n-link tw-break-words !tw-tracking-normal"
              target="_blank"
              rel="noreferrer"
            >
              {{ vars.companyRedressSchemeLinkUrl }}
            </a>
          </p>

          <div>
            <a
              v-for="(logo, index) in redress"
              :key="`redressLogos-${index}`"
              data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
            >
              <img style="max-height: 42px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
            </a>
          </div>
        </div>
      </div>

      <!-- En aşağıdaki içerikler -->
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-1 tw-pt-4 tw-text-xs">
        <!-- 1. Satır: Powered by -->
        <span class="tw-text-center">
          Powered by
          <a href="https://www.iceberg-digital.co.uk/neuron/home" target="_blank" class="n-link"> Neuron</a>
          |
          <a href="https://www.iceberg-digital.co.uk/" target="_blank" class="n-link">Iceberg Digital</a>
        </span>

        <!-- 2. Satır: Copyright -->
        <span class="mt-4 tw-text-center">
          © {{ new Date().getFullYear() }} Roderick Thomas Estate Agents. All rights reserved.
        </span>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineNuxtComponent, navigateTo } from '#app';
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';

interface MenuItem {
  name: string;
  url: string;
  has_sub_menu: boolean;
  is_open_new_tab: boolean;
  sub_menus?: MenuItem[];
}

export default defineNuxtComponent({
  name: 'RoderickThomasFooter',
  mixins: [ComponentMixin],

  data() {
    return {
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
    };
  },

  computed: {
    redress() {
      return this.groupedVariables.redress;
    },
    columns1() {
      return this.groupedVariables.columns1;
    },

    cards() {
      return this.groupedVariables.cards;
    },
    ...mapState(useWebsiteStore, ['company', 'headerMenuItems']),

    logo(): string {
      const currentCompany = this.company as any;
      const defaultLogo = currentCompany?.logo || '';
      // Hiçbir koşul olmaksızın sadece default logo dönsün.
      return defaultLogo;
    },

    footerMenuItems(): MenuItem[] {
      // headerMenuItems'ı footer için kullanıyorsan burayı düzenleyebilirsin
      return (this.headerMenuItems as MenuItem[]) || [];
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll(): void {
      this.isScrolled = window.scrollY > 50;
    },

    toggleSubMenu(index: number): void {
      // Açık olan alt menüyü tekrar tıklarsan kapatır, değilse açar
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    handleMenuLinkClick(menuItem: MenuItem): void {
      if (!menuItem || menuItem.has_sub_menu || !menuItem.url) return;
      navigateTo(menuItem.url, {
        external: !!menuItem.is_open_new_tab,
        open: { target: menuItem.is_open_new_tab ? '_blank' : '_self' },
      });
    },
  },
});
</script>

<style scoped>
.info p {
  font-family: var(--f-primary), sans-serif !important;
  font-weight: 300 !important;
  line-height: 160% !important;
  color: var(--c-text-tertiary) !important;
}
.info a:hover {
  color: var(--c-secondary) !important;
}
a:hover {
  color: var(--c-secondary) !important;
}

.footer {
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}

/* Submenu ilk etapta görünmesin */
.footer-submenu {
  display: none;
}

/* openSubMenu eşleştiğinde 'is-active' class'ı ile görünür */
.footer-submenu.is-active {
  display: block;
}

.footer-menu-item a {
  display: inline-flex;
  align-items: center;
}

.footer-submenu-item a {
  display: block;
}
</style>
